import a, { css as n } from "styled-components";
import { FloatingOverlay as e } from "./atoms-v280.js";
import { breakpoints as d } from "./atoms-v2125.js";
import { SMALL_DRAWER_HEIGHT_OFFSET as l, LARGE_DRAWER_WIDTH as s } from "./atoms-v2708.js";
import { Base as p } from "./atoms-v2777.js";
import { Text as x } from "./atoms-v243.js";
const o = n`
  align-items: center;
  justify-content: center;
`, b = a(e)`
  ${p}

  display: flex;
  overflow: hidden;
  position: relative;
  z-index: ${({ theme: i }) => {
  var r;
  return ((r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.zIndex.modal")) ?? 1e3;
}};

  &::before {
    background-color: ${({ $disabledOverlay: i }) => i ? "transparent" : "rgba(26 26 26 / 0.72)"};
    content: '';
    inset: 0;
    position: absolute;
  }

  ${({ $variant: i }) => i !== "drawer" ? n`
        ${o}
        padding: 8px;
      ` : n`
      align-items: flex-end;
      justify-content: center;
      padding: 0;
    `};

  @media ${d.medium} {
    ${({ $variant: i }) => i !== "drawer" ? n`
          padding: 32px;
        ` : o};
  }

  @media ${d.large} {
    ${({ $variant: i }) => i !== "drawer" ? n`
          padding: 40px;
        ` : n`
        align-items: center;
        justify-content: flex-end;
        padding: 0;
      `};
  }

  @media ${d.xLarge} {
    ${({ $variant: i }) => {
  if (i !== "drawer")
    return n`
          padding: 60px;
        `;
}};
  }
`, y = a.div`
  align-items: flex-start;
  background-color: ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return (t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.surface.${i}.background`);
}};
  border-radius: ${({ theme: i }) => {
  var r;
  return (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.radius.modalRadius");
}}px
    ${({ theme: i }) => {
  var r;
  return (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.radius.modalRadius");
}}px 0 0;
  box-shadow: 0 8px 20px 2px rgb(0 0 0 / 0.28);
  color: ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return (t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.text.${i}.primary`);
}};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  position: relative;

  ${({ $variant: i }) => i !== "drawer" ? n`
        bottom: 0;
        height: calc(100vh - 80px);
        left: 0;
        max-height: calc(100vh - 80px);
        max-width: 100%;
        min-height: calc(100vh - 80px);
        position: fixed;
        width: 100%;
      ` : n`
      height: 100%;
      max-height: calc(100vh * ${l});
      max-width: 100%;
      width: 100%;
    `};

  @media ${d.medium} {
    border-radius: ${({ theme: i }) => {
  var r;
  return (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.radius.modalRadius");
}}px;
    height: calc(100vh - 168px);
    max-height: calc(100vh - 168px);
    max-width: 100%;
    min-height: calc(100vh - 168px);
    min-width: 100%;
    width: 100%;

    ${({ $variant: i }) => {
  if (i !== "drawer")
    return n`
        width: ${s}px;
      `;
}}
  }

  @media ${d.large} {
    ${({ $variant: i }) => i !== "drawer" ? n`
          height: auto;
          max-width: 90%;
          min-height: 0;
          min-width: 640px;
          position: relative;
          width: auto;
        ` : n`
        height: 100%;
        max-height: 100%;
        width: 550px;
      `};
  }
`, v = a.header`
  align-items: center;
  border-bottom: ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return `solid 1px ${(t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.border.${i}.light`)}`;
}};
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: 2px 8px;
  width: 100%;

  @media ${d.large} {
    height: 56px;
    padding: 12px 16px;

    ${({ $variant: i }) => {
  if (i === "drawer")
    return `
         border-bottom: none;
      `;
}}
  }
`, k = a.div`
  width: 10%;

  @media ${d.large} {
    ${({ $variant: i }) => {
  if (i === "drawer")
    return `
        width: 0;
      `;
}}
  }
`, h = a.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  text-align: ${({ $alignment: i }) => i};
  width: 80%;

  @media ${d.large} {
    ${({ $variant: i }) => {
  if (i === "drawer")
    return `
        text-align: left;
        width: 90%;
      `;
}}
  }
`, H = a.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 10%;
`, R = a.section`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 24px;
  width: 100%;

  @media ${d.medium} {
    padding: 24px 32px;
  }

  @media ${d.large} {
    padding: 20px 32px 24px;
  }
`;
a.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
const j = a.footer`
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  margin-top: auto;
  padding: 20px 24px;
  width: 100%;

  @media ${d.medium} {
    padding: 20px 32px;
  }
`, T = a.div`
  align-items: center;
  border-bottom: ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return `solid 1px ${(t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.border.${i}.light`)}`;
}};
  display: flex;
  height: auto;
  margin-right: 2px;
  width: 16px;

  @media ${d.large} {
    width: 32px;
  }
`, L = a.div`
  align-items: flex-end;
  display: flex;
  flex: 1;
  height: 49px;
  max-height: 49px;
  width: 100%;

  @media ${d.large} {
    align-items: stretch;
    height: 57px;
    max-height: 57px;
  }
`, W = a.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0;
  width: 100%;

  @media ${d.large} {
    ${({ $variant: i }) => {
  if (i === "drawer")
    return `
         border-bottom: none;
      `;
}}
  }
`, E = a.div`
  align-items: center;
  align-self: center;
  border-bottom: solid 1px
    ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return (t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.border.${i}.light`);
}};
  display: flex;
  padding: 2px 8px 2px 0;

  @media ${d.large} {
    padding: 6px 16px 6px 0;
  }
`, _ = a.div`
  border-bottom: solid 1px
    ${({ $colorTheme: i = "light", theme: r }) => {
  var t;
  return (t = r == null ? void 0 : r.get) == null ? void 0 : t.call(r, `tokens.border.${i}.light`);
}};
  flex: 1;
  margin-left: 2px;
`, m = a(x)`
  color: ${({ $colorTheme: i = "light", theme: r }) => r.get(`tokens.text.${i}.primary`)};

  ${({ theme: i }) => i.get("tokens.body.expressive").toJS()}
`;
a.div`
  display: flex;
  flex: 1;
  min-width: 0;

  > * {
    max-width: 100%;
  }
`;
export {
  R as Content,
  y as Dialog,
  j as Footer,
  v as Header,
  h as HeaderCenter,
  L as HeaderContainerWithTabs,
  k as HeaderLeft,
  H as HeaderRight,
  E as HeaderRightWithTabs,
  _ as HeaderTabsSpacer,
  m as HeaderTitle,
  W as HeaderWithTabs,
  T as LeftPadding,
  b as Overlay
};
